export default function setVideo() {
  const videoWrapper = document.getElementById("js-video");
  const isMaybePlayWebm = videoWrapper.canPlayType("video/webm") === "maybe" ? true : false
  const isSp = window.matchMedia(`(max-width: 767px)`).matches;
  
  createSourceDom(videoWrapper,isMaybePlayWebm,isSp)
  window.addEventListener('resize', ()=>{
    const isSp = window.matchMedia(`(max-width: 767px)`).matches;
    createSourceDom(videoWrapper,isMaybePlayWebm,isSp)
  });
  //videoタグの srcに動画url指定
  //閲覧ブラウザでwebmが有効か確認する
  //ページ読み込んだら画面の幅を取得
  //ビデオタグのsrc属性にwebmあるいはmp4をセット
}

const createSourceDom = (wrapper,isMaybePlayWebm,isSp) => {
  const extension = isMaybePlayWebm ? "webm" : "mp4"
  const path = "../assets/mov/"
  const filePath = isSp ? `${path}metaverse_mv_sp` : `${path}metaverse_mv`
  wrapper.setAttribute("src", `${filePath}.${extension}`);
  wrapper.setAttribute("type", `video/${extension}`);
};



// WEBPACK FOOTER //
// ./src/recruit/js/setVideo.js